module.exports = {"id":"208564","name":"Peter Ankersen","rating":"72","photo":"./data/images/photos/2/208564.png","club":{"name":"FC Copenhague","logo":"./data/images/clubs/FCCopenhague.png"},"positions":["DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PeterAnkersen0.json
// module id = 3440
// module chunks = 0